module.exports = __webpack_public_path__ + "static/img/first.8e16e139.png";